import React from 'react';
import Header from './Header';
import { logo, emailLink } from './Header.module.scss';
import logoS from '../../../images/logo-top.svg';

const IndustratorLogo = () => (
  <img src={logoS} className={logo} width="20" height="20" viewBox="0 0 31 31" />
);

const CustomHeader = (props) => (
  <Header 
    {...props}
    globalBarContent={
      <a href="mailto:sales@hegen.ru" className={emailLink}>sales@hegen.ru</a>
    }
  >
    <IndustratorLogo />&nbsp;<span>Hegen</span>
  </Header>
);

export default CustomHeader;
